import React from 'react';
import { NavLink } from 'react-router-dom';

export default function Sidebar({ collapsed, onToggle }) {
  return (
    <aside className="gp-sidebar gp-sidebar-blue text-white">
      <div className="d-flex align-items-center p-3">
        <div className="me-2 fs-5">🛡️</div>
        {!collapsed && <div className="fw-bold">GP Vigilancia</div>}
      </div>
      <nav className="nav flex-column gap-1 px-2">
        <div className="text-uppercase small text-secondary px-2 mt-2">{!collapsed ? 'Gestión' : ''}</div>
        <SideItem to="/gestion/rondas-en-vivo" icon="bi bi-person-walking" color="text-white" label="Rondas en Vivo" collapsed={collapsed} />
        <SideItem to="/gestion/patios" icon="bi-geo-alt" color="text-warning" label="Patios" collapsed={collapsed} />
        <SideItem to="/gestion/personal" icon="bi-people" color="text-info" label="Personal" collapsed={collapsed} />
        <SideItem to="/gestion/asignacion" icon="bi-calendar3" color="text-secondary" label="Asignación" collapsed={collapsed} />
        {/* <SideItem to="/gestion/asignacion-automatica" icon="bi-magic" color="text-primary" label="Asignación Automática" collapsed={collapsed} /> */}
        <SideItem to="/gestion/contactos" icon="bi-telephone" color="text-success" label="Contactos de Emergencia" collapsed={collapsed} />
        <SideItem to="/gestion/incidencias" icon="bi-exclamation-circle" color="text-danger" label="Incidencias" collapsed={collapsed} />
        {/* <SideItem to="/gestion/seguimiento-ubicaciones" icon="bi-geo-alt-fill" color="text-secondary" label="Seguimiento Ubicaciones" collapsed={collapsed} /> */}

        <div className="text-uppercase small text-secondary px-2 mt-3">{!collapsed ? 'Reportes' : ''}</div>
        <SideItem to="/reportes/rondas" icon="bi-radar" color="text-primary" label="Historial de rondas" collapsed={collapsed} />
        {/* <SideItem to="/reportes/incidencias" icon="bi-exclamation-triangle" color="text-danger" label="Trazabilidad de Incidencias" collapsed={collapsed} /> */}
        <SideItem to="/reportes/rondas-planificadas-vs-completadas" icon="bi bi-calendar-check" color="text-white" label="Rondas Planificadas vs Completadas" collapsed={collapsed} />
        <SideItem to="/reportes/tiempo-promedio-puntos-control" icon="bi bi-stopwatch" color="text-white" label="Tiempo promedio por Punto de Control" collapsed={collapsed} />
        <SideItem to="/reportes/incidencias-tiponivel" icon="bi-exclamation-triangle" color="text-danger" label="Incidencias por Tipo y Nivel" collapsed={collapsed} />
      </nav>

      {/* Toggle inferior eliminado; usar el botón superior en la barra blanca */}
    </aside>
  );
}

function SideItem({ to, icon, label, collapsed, color }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `gp-sideitem d-flex align-items-center gap-2 px-2 py-2 rounded ${isActive ? 'active' : ''}`
      }
    >
      <i className={`bi ${icon} ${color || ''}`} />
      {!collapsed && <span>{label}</span>}
    </NavLink>
  );
}
